<template lang="pug">
.box-header-top.sticky-front-top
  nav.navbar.navbar-transparent.navbar-absolute
    .container-fluid
      .navbar-header
        .menu-header
          button.navbar-toggle(type='button', data-toggle='collapse', @click='toggleSideBar')
            span.sr-only Toggle navigation
            span.icon-bar
            span.icon-bar
            span.icon-bar
          router-link(:to="{ name: 'body'}") Trang chủ
          router-link(:to="{ name: 'body'}") Liên hệ
        //- a.navbar-brand(href='#') {{$route.name}}
      .navbar-collapse
        navbar-right
        //- navbar-search
</template>
<script>
import NavbarSearch from './navbar-search'
import NavbarRight from './navbar-right'

export default {
  components: {
    NavbarSearch,
    NavbarRight
  },
  methods: {
    toggleSideBar() {
      // console.log('emit up origin')
      this.$emit('toggleSideBar')
    }
    // hiddenSideBar() {
    //   console.log('emit up')
    //   this.$emit('toggleSideBar')
    // }
  }
}
</script>
<style lang="scss">
.box-header-top{min-height: 74px;
  &.sticky-front-top{top:0;left: 0; width: 100%; position: sticky; z-index: 9999;}
  .navbar.navbar-transparent{border-radius: 0;
    .container-fluid{
      .navbar-header{padding-top: 10px;float: left;
        .menu-header{display: inline-block; line-height: 40px;
          button.navbar-toggle{display: block; float:left; margin: 0;
            span.icon-bar{border: 1px solid #343A40; background-color: transparent; display:block; margin-top:4px;
              &:first-child{margin-top:0;}
            }
          }
          a {color:  #343A40;position: relative; padding: 10px 20px;font-size: 16px;}
        }
      }
    }
  }
}
.main-panel{
  .content{margin-top: 0; padding: 15px;}
}
@media (max-width: 991px){
  .navbar.navbar-transparent {padding: 0;
    .container-fluid{
      .navbar-header{ padding:0; line-height: 50px;
        .menu-header{
          a{padding: 10px;}
        }
      }
      .navbar-collapse{padding: 0 5px;
        .navbar-nav.navbar-right{height: 50px; float: right; margin: 0;
          li{float: left; display: block;
            &.open{position: relative;
              .dropdown-menu{position: fixed;background: #fff; margin: 0 15px;width: calc(100% - 30px);top:51px;box-shadow: 0px 3px 6px #00000029;}
            }
            a{padding: 13px 5px;
              p{display: none;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0ec599e4